import { fetchFromApi } from '../../helpers/api';

export const LanguagesActionTypes = {
  GET_LANGUAGES_REQUEST: 'LANGUAGES/GET_LANGUAGES_REQUEST',
  GET_LANGUAGES_SUCCESS: 'LANGUAGES/GET_LANGUAGES_SUCCESS',
  GET_LANGUAGES_FAILURE: 'LANGUAGES/GET_LANGUAGES_FAILURE'
};

export const getLanguages = () => {
  const headers = new Headers();

  const init = {
    method: 'GET',
    headers
  };

  return {
    types: [
      LanguagesActionTypes.GET_LANGUAGES_REQUEST,
      LanguagesActionTypes.GET_LANGUAGES_SUCCESS,
      LanguagesActionTypes.GET_LANGUAGES_FAILURE
    ],
    shouldCallApi: state => state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi('languages/', init, dispatch)
  };
};



/** WEBPACK FOOTER **
 ** ./src/state/languages/actions.js
 **/